import { getWorksList } from "@/server/interfaces"
import { resolveImgToSmall } from "@/utils/resolveImgToSmall"
import resolveDefaultOpt from "@/utils/resolveDefaultOpt"

export default {
  namespaced: true,
  state: {
    worksList: [],
    noMoreWorkList: false,
    scrollTop: 0
  },
  getters: {
    worksList: state => state.worksList,
    noMoreWorkList: state => state.noMoreWorkList,
    scrollTop: state => state.scrollTop
  },
  mutations: {
    refreshWorksList(state, workList) {
      state.worksList = workList
    },
    saveWorksList(state, workList) {
      state.worksList = [...state.worksList, ...workList]
    },
    setNoMoreWorksList(state, status) {
      state.noMoreWorkList = status
    },
    reviseWorkItem(state, { index, workItem }) {
      const oldWorkItem = state.worksList[index]
      const newWorkItem = { ...oldWorkItem, ...workItem }
      state.worksList.splice(index, 1, newWorkItem)
    },
    saveScrollTop(state, scrollTop) {
      state.scrollTop = scrollTop
    }
  },
  actions: {
    async getWorksList({ commit, rootState }, params) {
      const activityId = rootState.activityInfo.activityId
      params.params.activityId = activityId
      const {
        params: { page }
      } = params
      const { content: workList, last } = await getWorksList(params)
      workList.forEach(item => {
        Object.assign(item, item.defaultOpt, resolveDefaultOpt(item.defaultOpt))
        item.mediaFiles = item.mediaFiles || []
        item.videos = item.videos || []
        const mediaCoverItem = item.mediaFiles.find(item => item.cover)
        const mediaCover = mediaCoverItem ? mediaCoverItem.url : ""
        const imgFilesCover = item.mediaFiles[0] ? item.mediaFiles[0].url : ""
        const videoCover = item.videos[0] ? item.videos[0].coverImgUrl : ""
        item.cover = mediaCover || videoCover || imgFilesCover || item.worksDefaultPic
        item.cover = resolveImgToSmall(item.cover)
      })
      if (page === 0) {
        commit("refreshWorksList", workList)
      } else {
        commit("saveWorksList", workList)
      }
      commit("setNoMoreWorksList", last)
    }
  }
}
